import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
import React, { useContext } from 'react';
import { Col } from '../Col';
import { FormContext } from './FormContext';
export const ControlLabel = /*#__PURE__*/ React.forwardRef(({ componentClass: Component = 'label', column = false, srOnly = false, className, htmlFor, ...props }, ref)=>{
    const { controlId } = useContext(FormContext);
    let columnClass = 'col-form-label';
    if (typeof column === 'string') columnClass = `${columnClass} ${columnClass}-${column}`;
    const classes = classNames(className, 'form-label', srOnly && 'sr-only', column && columnClass);
    const htmlForId = htmlFor || controlId;
    if (column) return /*#__PURE__*/ _jsx(Col, {
        componentClass: "label",
        className: classes,
        htmlFor: htmlForId,
        ...props
    });
    return /*#__PURE__*/ _jsx(Component, {
        ref: ref,
        className: classes,
        htmlFor: htmlForId,
        ...props
    });
});
ControlLabel.displayName = 'ControlLabel';
